import { kebabCase } from 'lodash-es';

export enum SuggestionDatasetKey {
  ID = 'suggestionId',
}

export const SUGGESTION_ID_DATA_ATTRIBUTE = `data-${kebabCase(
  SuggestionDatasetKey.ID,
)}`;
